export interface ICommentDto {
    comment: string;
    createdBy: string;
}
